import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import { Ref } from 'vue';
import GetTagListRequest from '@/api/dictionary/tag-list.request';
import GetSegmentListRequest from '@/api/dictionary/segment-list.request';
import GetCountryListRequest from '@/api/dictionary/get-country-list.request';
import GetPaymentSystemListRequest from '@/api/dictionary/payment-system-list.request';
import GetWhitelabelListRequest from '@/api/dictionary/get-whitelabel-list.request';
import GetDocumentModerationFilterStatusListRequest
  from '@/api/dictionary/get-document-moderation-filter-status-list.request';
import GetConditionListRequest from '@/api/dictionary/get-condition-list.request';

export class DictionaryApiResources {
  public constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly multibrandApiHost: Ref<string>,
    private readonly multibrandApiUrl: Ref<string>,
  ) { }

  public get getTagListRequest(): GetTagListRequest {
    return new GetTagListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/tag/dictionary`,
      HttpMethods.GET,
    );
  }

  public get getSegmentListRequest(): GetSegmentListRequest {
    return new GetSegmentListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/segment/dictionary`,
      HttpMethods.GET,
    );
  }

  public get getCountryListRequest(): GetCountryListRequest {
    return new GetCountryListRequest(
      this.requestPerformer,
      `${this.multibrandApiUrl.value}/dictionary/country`,
      HttpMethods.GET,
    );
  }

  public get getConditionListRequest(): GetConditionListRequest {
    return new GetConditionListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/proxy`,
      HttpMethods.GET,
    );
  }

  public get getPaymentSystemListRequest(): GetPaymentSystemListRequest {
    return new GetPaymentSystemListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/paymentSystem/dictionary`,
      HttpMethods.GET,
    );
  }

  public get getWhitelabelListRequest(): GetWhitelabelListRequest {
    return new GetWhitelabelListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/whitelabel/dictionary`,
      HttpMethods.GET,
    );
  }

  public get getDocumentModerationFilterStatusListRequest(): GetDocumentModerationFilterStatusListRequest {
    return new GetDocumentModerationFilterStatusListRequest(
      this.requestPerformer,
      `${this.multibrandApiHost.value}/api/v1.0/front/proxy`,
      HttpMethods.GET,
    );
  }
}
